import type { ReportMessages } from '../de/report.js';

export const report: ReportMessages = {
  title: 'Raport projektowy',
  fileWord: 'Raport-projektowy',
  disclaimer:
    'Planowanie koncepcyjne/projektowe – nie jest projektem wykonawczym, budowlanym ani konstrukcyjnym.',
  header: '{title} · Stan na {date} · Rewizja {revision}',
  page: 'Strona {page} z {total}',
  createdBy: 'Raport projektowy z {date} · autor: {author}',
  description: 'Opis projektu',
  figuresTitle: 'Wskaźniki',
  noView: 'Nie przesłano widoku 3D.',
  plan: 'Rzut',
  planLevel: 'Rzut {level}',
  nothingPlanned: 'Jeszcze nic nie zaplanowano.',
  scale: 'Skala 1:{scale}',
  scaleHint: 'przy druku na A4 bez skalowania',
  legendTitle: 'Legenda',
  unitsMeters: 'Wymiary w metrach',
  units: 'Wymiary w {unit}',
  north: 'N',
  view: 'Widok 3D {n}',
  views: { southEast: 'Widok od południowego wschodu', northWest: 'Widok od północnego zachodu' },
  tablesTitle: 'Powierzchnie i elementy',
  tablesContinued: 'Powierzchnie i elementy (ciąg dalszy)',
  notesTitle: 'Uwagi z planowania',
  notesHint:
    'Uwagi są geometrycznymi kontrolami wiarygodności i nie zastępują projektu branżowego.',
  total: 'Razem',
  sum: 'Suma',
  roofTypes: { gable: 'Dach dwuspadowy', mono: 'Dach jednospadowy', flat: 'Dach płaski' },
  figures: {
    site: 'Działka',
    parcels: 'Działki ewidencyjne',
    built: 'Powierzchnia zabudowy',
    coverage: 'Wskaźnik zabudowy (zabudowa / działka)',
    free: 'Wolna powierzchnia działki',
    halls: 'Hale',
    offices: 'Budynki biurowe',
    officeArea: 'Powierzchnia biurowa (brutto, wszystkie kondygnacje)',
    traffic: 'Powierzchnie komunikacyjne',
    carStalls: 'Miejsca postojowe dla samochodów',
    truckStalls: 'Miejsca postojowe dla ciężarówek',
    fence: 'Długość ogrodzenia',
    palletPlaces: 'Miejsca paletowe',
    shelfPlaces: 'Miejsca na półkach',
    shelfArea: 'Powierzchnia półek',
  },
  parcels: {
    title: 'Działka (działki ewidencyjne)',
    columns: ['Działka', 'Powierzchnia', 'Obwód'],
  },
  offices: {
    title: 'Budynki biurowe',
    columns: [
      'Budynek',
      'Położenie',
      'Wymiary zewnętrzne',
      'Kondygnacje (wysokość w świetle)',
      'Strop',
      'Wysokość całkowita',
      'Pow. brutto',
    ],
    indoor: 'Zabudowa wewnętrzna',
    indoorIn: 'Zabudowa w {hall}',
    freestanding: 'wolnostojący',
    usableTop: 'strop użytkowy',
  },
  roomBook: {
    title: 'Zestawienie pomieszczeń {name}',
    columns: ['Kondygnacja', 'Pomieszczenie', 'Rodzaj', 'Powierzchnia', 'Wysokość w świetle'],
    unassigned: 'nieprzypisane',
    rooms: {
      one: '{n} pomieszczenie',
      few: '{n} pomieszczenia',
      many: '{n} pomieszczeń',
      other: '{n} pomieszczenia',
    },
  },
  stairs: {
    title: 'Schody',
    columns: [
      'Schody',
      'Budynek',
      'Połączenie',
      'Szerokość biegu',
      'Stopnie',
      'Wysokość / głębokość',
      'Rzut',
    ],
    enclosed: '{name} (klatka schodowa)',
    landing: '{name}, spocznik {length}',
    ratio: '{riser} / {going} cm',
  },
  halls: {
    title: 'Hale',
    freeOutline: 'Dowolny obrys (narożniki: {n})',
    columns: [
      'Hala',
      'Wymiary zewnętrzne',
      'Powierzchnia',
      'Pow. użytkowa wewn.',
      'Okap / kalenica',
      'Dach',
      'Otwory',
    ],
  },
  mezzanines: {
    title: 'Antresole w halach (1. piętro)',
    columns: ['Antresola', 'Hala', 'Poziom podłogi', 'Strop', 'Wyposażenie', 'Powierzchnia'],
    railing: 'Balustrada',
    columns_: 'Słupy',
  },
  mezzanineAreas: {
    title: 'Podział {name} (według ścian, bez grubości ścian)',
    columns: ['Obszar', 'Powierzchnia', 'Udział'],
  },
  zones: {
    title: 'Podział powierzchni {name}',
    columns: ['Obszar', 'Rodzaj', 'Powierzchnia', 'Udział'],
    room: 'Pomieszczenie',
    unplanned: 'jeszcze niezaplanowane',
    interior: 'Pow. użytkowa wewn.',
  },
  sections: {
    title: 'Obszary hali {name} (wg ścian działowych, mierzone do osi ściany)',
    columns: ['Obszar', 'Powierzchnia', 'Udział'],
  },
  outdoorZones: {
    title: 'Powierzchnie zewnętrzne',
    columns: ['Powierzchnia', 'Rodzaj', 'Wielkość'],
  },
  openings: {
    title: 'Bramy, drzwi i okna',
    columns: ['Hala', 'Typ', 'Wymiary (S × W)', 'Liczba'],
    interiorWalls: 'Ściany wewnętrzne',
    sill: 'parapet {length}',
    bay: 'dojazd {width} × {length}',
  },
  roof: {
    title: 'Elementy dachu',
    columns: ['Hala', 'Element', 'Liczba', 'Powierzchnia'],
    daylight: 'Udział światła dziennego w dachu',
  },
  objects: {
    title: 'Obiekty',
    columns: ['Nazwa', 'Wymiary (S × G × W)', 'Liczba'],
  },
  racks: {
    title: 'Regały paletowe',
    columns: [
      'Regał',
      'Belka',
      'Pola',
      'Poziomy',
      'Miejsca 1,60 m',
      'Miejsca 0,80 m',
      'Miejsca paletowe',
    ],
  },
  shelves: {
    title: 'Regały półkowe',
    columns: [
      'Regał',
      'Wysokość',
      'Pola',
      'Poziomy',
      'Miejsca (karton 30 × 60 cm)',
      'Powierzchnia półek',
    ],
  },
  facilities: {
    title: 'Zagospodarowanie terenu',
    columns: ['Nazwa', 'Rodzaj', 'Wymiary', 'Powierzchnia'],
    road: 'szer. {width}, dł. {length}',
    parking: '{stall}, alejka {aisle}',
    fence: 'Ogrodzenie',
    fenceSize: 'dł. {length}, wys. {height}',
  },
  legend: {
    site: 'Granica działki',
    parcel: 'Granica działki ewidencyjnej',
    hall: 'Hala / ściana zewnętrzna',
    room: 'Pomieszczenie',
    dock: 'Dojazd do rampy (obniżony)',
    object: 'Obiekt',
    clearance: 'Odstęp ochronny/obsługowy',
    roofElement: 'Element dachu (powyżej)',
    road: 'Droga / ścieżka',
    parking: 'Parking',
    fence: 'Ogrodzenie',
    measure: 'Wymiar',
    stair: 'Schody (strzałka = w górę)',
  },
};
